import request from "@/utils/request";

export default function getMarketPlaceIdsByMerchantId(merchantId) {
    return request({
        url: `/merchantMarketPlace/listByMerchantId/`+merchantId,
        method: 'get',
    })
}
